import { AnalyticsContext } from '@atlaskit/analytics-next';
import React, { memo } from 'react';
import { LazySuspense, lazyForPaint } from 'react-loosely-lazy';
import { COMPONENT_NAME } from '../common/constants';
import { name as packageName, version as packageVersion } from '../version.json';
import ErrorBoundary from './error-boundary';
import { LoaderFallback } from './loader-fallback';
import { LinkPickerSessionProvider } from '../controllers/session-provider';
export var PACKAGE_DATA = {
  packageName: packageName,
  packageVersion: packageVersion,
  componentName: COMPONENT_NAME,
  source: COMPONENT_NAME
};
var LazyLinkPicker = lazyForPaint(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_link-picker" */
  './link-picker');
});
export var ComposedLinkPicker = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: PACKAGE_DATA
  }, /*#__PURE__*/React.createElement(LinkPickerSessionProvider, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement(LoaderFallback, {
      hideDisplayText: props.hideDisplayText
    })
  }, /*#__PURE__*/React.createElement(LazyLinkPicker, props)))));
});
export default ComposedLinkPicker;